import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { UserData } from '@food/auth';
import { switchManaged } from '../utils/switch';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { parseGraphqlError, sentryHandler } from '../utils/errors';

const otherManagedQuery = gql`
	query OtherManagedQuery {
		currentUser {
			id
			managedByUsers(currentOnly: false) {
				id
				capabilities
				Company {
					id
					name
					billingBranch {
						id
						Country {
							id
							code
						}
					}
				}
			}
		}
	}
`;

interface NavbarProps {
	sidebarIsOpen: boolean;
	onToggleSidebar: () => void;
}

export class Navbar extends React.Component<NavbarProps, any> {
	state = {
		userDropdownIsOpen: false,
	};

	_toggleUserDropdown = () => {
		this.setState({
			userDropdownIsOpen: !this.state.userDropdownIsOpen,
		});
	};

	renderUserDropdown() {
		return (
			<UserData>
				{({ userData, managedCompany }) => {
					let loginName =
						userData.firstName || userData.lastName
							? userData.firstName + ' ' + userData.lastName
							: userData.email;
					if (managedCompany) {
						loginName = `${loginName} (${managedCompany.Company.name})`;
					}

					return (
						<Query<any, any> query={otherManagedQuery}>
							{({ error, loading, data }) => {
								if (error) {
									sentryHandler(parseGraphqlError(error));
									return null;
								}

								if (loading) {
									return null;
								}

								const otherManagedCompanies = data.currentUser.managedByUsers
									.filter((m) => m.Company)
									.filter(
										(m) =>
											managedCompany &&
											managedCompany.Company.id !== m.Company.id,
									);

								return (
									<Dropdown
										isOpen={this.state.userDropdownIsOpen}
										toggle={this._toggleUserDropdown}
									>
										<DropdownToggle caret={true}>
											{loginName}{' '}
											<i className="fa fa-caret-down" />
										</DropdownToggle>
										<DropdownMenu right>
											{otherManagedCompanies.length > 0 && (
												<>
													<DropdownItem header>
														Altri profili aziendali:
													</DropdownItem>
													{otherManagedCompanies.map(
														(managed) => (
															<DropdownItem
																key={managed.id}
																onClick={() =>
																	switchManaged(
																		managed.Company.id,
																	)
																}
															>
																{managed.Company.name}
															</DropdownItem>
														),
													)}
													<DropdownItem divider />
												</>
											)}
											<Link to="/logout">
												<DropdownItem>
													<i className="fa fa-user" /> Logout
												</DropdownItem>
											</Link>
										</DropdownMenu>
									</Dropdown>
								);
							}}
						</Query>
					);
				}}
			</UserData>
		);
	}

	render() {
		const { sidebarIsOpen, onToggleSidebar } = this.props;

		return (
			<header className="topbar">
				<nav className="navbar top-navbar navbar-expand-md navbar-light">
					<div className="navbar-header">
						<button
							type="button"
							className="sidebar-toggle"
							aria-label="Menu"
							aria-expanded={sidebarIsOpen}
							onClick={onToggleSidebar}
						>
							<i className="mdi mdi-menu" />
						</button>
					</div>
					<div className="navbar-collapse">
						<ul className="navbar-nav mr-auto mt-md-0 " />
						<div className="pull-right">{this.renderUserDropdown()}</div>
					</div>
				</nav>
			</header>
		);
	}
}
